var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid",staticStyle:{"padding-top":"76px","min-height":"calc(100vh)"}},[_c('Nav'),_c('div',{staticClass:"container-main"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }